import { getObject, putObject, postVoid, StringOrNothing, deleteObject, deleteVoid } from "../ChoiceApi";
import { IFishboneCreatePayload,
            IFishboneOrder,
            IFishboneOrderLocation,
            IFishboneOrderResult,
            IFishboneSubType,
            IFishboneType,
            IWireframe,
            IWireframeConfiguration, 
            IWireframeCreatePayload} from "../Models/Fishbones";

export async function getFishboneTypes(): Promise<IFishboneType[] | undefined> {
    return await getObject("api/Fishbones/Types");
}

export async function getFishboneSubTypes(): Promise<IFishboneSubType[] | undefined> {
    return await getObject(`api/Fishbones/SubTypes`);
}

export async function getFishboneOrders(): Promise<IFishboneOrder[] | undefined> {
    return await getObject(`api/Fishbones/Orders`);
}

export async function getFishboneOrderLocations(): Promise<IFishboneOrderLocation[] | undefined> {
    return await getObject(`api/Fishbones/OrderLocations`);
}

export async function getFishboneOrderResults(): Promise<IFishboneOrderResult[] | undefined> {
    return await getObject(`api/Fishbones/OrderResults`);
}

export async function updateFishbones(fishbones: IFishboneType[]): Promise<IFishboneType[] | undefined> {
    return await putObject(`api/Fishbones/Fishbone/update`, fishbones);
}

export async function updateFishboneSubTypes(fishboneSubTypes: IFishboneSubType[]): Promise<IFishboneSubType[] | undefined> {
    return await putObject(`api/Fishbones/FishboneSubType/update`, fishboneSubTypes);
}

export async function updateFishboneOrders(fishboneOrders: IFishboneOrder[]): Promise<IFishboneOrder[] | undefined> {
    return await putObject(`api/Fishbones/FishboneOrder/update`, fishboneOrders);
}

export async function createFishbone(fishbonePayload: IFishboneCreatePayload): Promise<StringOrNothing> {
    return await postVoid(`api/Fishbones/Fishbone/add`, fishbonePayload);
}

export async function deleteFishboneResult(fishbonePayload: IFishboneOrderResult): Promise<IFishboneOrderResult[] | undefined> {
    return await deleteObject(`api/Fishbones/Fishbone/delete`, fishbonePayload);
}

export async function getWireframes(fbId: number): Promise<IWireframe[] | undefined> {
    return await getObject(`api/Fishbones/Wireframes/${fbId}`);
}

export async function getWireframeConfigs(): Promise<IWireframeConfiguration[] | undefined> {
    return await getObject(`api/Fishbones/WireframeConfigurations`);
}

export async function CreateWireframe(wireframe: IWireframeCreatePayload): Promise<StringOrNothing> {
    return await postVoid(`api/Fishbones/Wireframe/Create`,wireframe);
}

export async function updateWireframe(wireframe: IWireframe): Promise<StringOrNothing> {
    return await postVoid(`api/Fishbones/Wireframe/Update`,wireframe);
}

export async function deleteWireframe(wireframe: IWireframe): Promise<StringOrNothing> {
    return await deleteVoid(`api/Fishbones/Wireframe/Delete`,wireframe);
}

export async function createOrUpdateWireframeConfig(wireframeConfigs: IWireframeConfiguration[]): Promise<StringOrNothing> {
    return await postVoid(`api/Fishbones/WireframeConfigurations/Update`,wireframeConfigs);
}